<app-articledetail
  [docID]="data.docID"
  [s3_file_url]="data.s3_file_url"
  [draftContent]="data.draftContent"
></app-articledetail>
